/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type MutationResult = "failure" | "skipped" | "success" | "%future added value";
export type goalsAddGoalMutationVariables = {
    readonly participant_id: string;
    readonly label: string;
};
export type goalsAddGoalMutationResponse = {
    readonly addParticipantGoal: ({
        readonly goal: ({
            readonly id: string;
            readonly label: string;
            readonly created_at: string;
            readonly completed_at: string | null;
        }) | null;
        readonly result: MutationResult;
        readonly description: string | null;
        readonly errors: ReadonlyArray<string | null> | null;
    }) | null;
};
export type goalsAddGoalMutation = {
    readonly response: goalsAddGoalMutationResponse;
    readonly variables: goalsAddGoalMutationVariables;
};



/*
mutation goalsAddGoalMutation(
  $participant_id: String!
  $label: String!
) {
  addParticipantGoal(participant_id: $participant_id, label: $label) {
    goal {
      id
      label
      created_at
      completed_at
    }
    result
    description
    errors
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "participant_id",
            "type": "String!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "label",
            "type": "String!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "addParticipantGoal",
            "storageKey": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "label",
                    "variableName": "label"
                },
                {
                    "kind": "Variable",
                    "name": "participant_id",
                    "variableName": "participant_id"
                }
            ],
            "concreteType": "NewParticipantGoal",
            "plural": false,
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "goal",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ParticipantGoal",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "id",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "label",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "created_at",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "completed_at",
                            "args": null,
                            "storageKey": null
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "result",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "description",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "errors",
                    "args": null,
                    "storageKey": null
                }
            ]
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "goalsAddGoalMutation",
            "type": "Mutation",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "operation": {
            "kind": "Operation",
            "name": "goalsAddGoalMutation",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "params": {
            "operationKind": "mutation",
            "name": "goalsAddGoalMutation",
            "id": null,
            "text": "mutation goalsAddGoalMutation(\n  $participant_id: String!\n  $label: String!\n) {\n  addParticipantGoal(participant_id: $participant_id, label: $label) {\n    goal {\n      id\n      label\n      created_at\n      completed_at\n    }\n    result\n    description\n    errors\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '8a3355a5d416994509b8b4edc2e34015';
export default node;
